import { writable } from 'svelte/store';
import type { ParsedTlck, QueueState } from './tlck.js';

export type QueueItem = {
  id: string;
  file: File | null;
  tlckBytes: Uint8Array;
  parsed: ParsedTlck;
  state: QueueState;
  releasePriv?: Uint8Array;
  decryptedBlobUrl?: string;
  /** Plaintext byte length after successful decryption; populated in `state === "done"`. */
  decryptedSize?: number;
  error?: string;
  addedAt: number;
};

function createQueue() {
  const { subscribe, update, set } = writable<QueueItem[]>([]);

  return {
    subscribe,
    add(item: QueueItem) {
      update((items) => {
        if (items.find((x) => x.id === item.id)) return items;
        const next = [...items, item];
        next.sort((a, b) => {
          const at = a.parsed.header.unlock_unix ?? Number.MAX_SAFE_INTEGER;
          const bt = b.parsed.header.unlock_unix ?? Number.MAX_SAFE_INTEGER;
          return at - bt;
        });
        return next;
      });
    },
    updateItem(id: string, patch: Partial<QueueItem>) {
      update((items) => items.map((x) => (x.id === id ? { ...x, ...patch } : x)));
    },
    remove(id: string) {
      update((items) => items.filter((x) => x.id !== id));
    },
    clear() {
      set([]);
    },
  };
}

export const queue = createQueue();

export type Page = 'app' | 'about' | 'notfound';
export type AppTab = 'encrypt' | 'decrypt';

export const currentPage = writable<Page>('app');
export const activeTab = writable<AppTab>('encrypt');
